import { Component, Input, OnInit } from '@angular/core'
import { fullDayNoYear, isVideoPlanCode } from 'utils'
import { Customer, SubmissionQueries } from '../../submission.queries'
import moment from 'moment'
import { allowedContentTypes } from 'src/modules/keywords/utils'
import { IContentType } from 'src/graphql/queries/keyword.queries'

@Component({
  selector: 'empty-no-requests',
  template: `
    <no-preferred-writers-modal *ngIf="noPreferredWritersModalVisible" (close)="noPreferredWritersModalVisible = false"></no-preferred-writers-modal>
    <div class="text-center mt-3 mb-2 empty-state">
      <i class="fas fa-exclamation-circle"></i>
      <h2>No Active Requests</h2>
      <div class="d-md-flex flex-row justify-content-center align-items-start">
        <div class="col-md-5">
          <div class="well vertical-buffer vertical-padding">
            <p>
              Without active requests, you won't receive submissions to review.
            </p>
            <p class="small text-muted">
              Click <a [routerLink]="['/dashboard', customer.id, 'topics']">Requests</a> to view, edit, and add new requests.
            </p>
            <div class="btn-group" dropdown placement="bottom left">
              <button dropdownToggle class="btn btn-primary">
                Create a Request
              </button>
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-left">
                <li *ngFor="let contentType of contentTypes">
                  <a class="dropdown-item" [routerLink]="['../topics/new', contentType.id]">
                    {{contentType.name}}
                  </a>
                </li>
                <li><a class="dropdown-item" href="https://help.verblio.com/quick-guide-to-verblio/how-to-specify-content-types" target="_blank">Looking for another type? <i class="ml-1 fas fa-question-circle text-primary"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-5" *ngIf="!isVideoCustomer">
          <div class="well vertical-buffer vertical-padding">
            <p>Need blog topics?</p>
            <p class="small text-muted">
              Get 10 blog topic ideas quickly from our Inbound-certified experts.
            </p>
            <div class="top-buffer">
              <a *ngIf="canPurchaseTopics" [routerLink]="['/dashboard', customer.id, 'topics']" [queryParams]="{purchaseTopicsModal: true}" class="btn btn-primary">Learn More</a>
              <p *ngIf="!canPurchaseTopics" class="small">
                You last requested ideas on
                {{mTopicsPurchaseDate.format('MM/DD')}}—please check back under
                <a [routerLink]="['/dashboard', customer.id, 'proposed_topics']">Topic Ideas</a> on
                {{mTopicsPurchaseDate.add(2, 'days').format('MM/DD')}} to review.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
})
export class EmptyNoRequestsComponent implements OnInit {
  @Input() customer: Customer;
  noPreferredWritersModalVisible: boolean = false;
  contentTypes: IContentType[] = []

  constructor(private submissionQueries: SubmissionQueries) {}

  ngOnInit(): void {
    this.submissionQueries.contentTypes().subscribe((data: IContentType[]) => {
      if (!data) return

      if (this.customer?.multipass) {
        this.contentTypes = data
      } else {
        this.contentTypes = allowedContentTypes(data, this.customer?.subscription.plan.words)
      }
    })
  }

  formatted(date: Date): string {
    return fullDayNoYear(date)
  }

  get mTopicsPurchaseDate(): moment.Moment {
    return this.customer && this.customer.lastTopicsPurchaseDate && moment(this.customer.lastTopicsPurchaseDate)
  }
  get canPurchaseTopics(): boolean {
    if (this.customer.lastTopicsPurchaseDate) {
      const lastPurchase = this.mTopicsPurchaseDate
      const twoDaysAgo = moment().subtract(2, 'days') // From keywords-layout.ts#checkPurchases
      return lastPurchase.isBefore(twoDaysAgo)
    } else {
      return true
    }
  }

  get isVideoCustomer(): boolean {
    if(this.customer.multipass) {
      return false
    }
    return isVideoPlanCode(this.customer.subscription.plan.code)
  }

  get purchaseTenTopicsDisabledMessage(): string {
    if (this.customer.lastTopicsPurchaseDate) {
      const mTopicsPurchaseDate = moment(this.customer.lastTopicsPurchaseDate)
      const mCheckBack = mTopicsPurchaseDate.add(2, 'days')
      return ``
    }
  }
}
